import React from "react"
import ConsoleDashboardStore from "../../ConsoleDashboardStore";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {observer} from "mobx-react";

const OrthoptistsFilter = observer(() => {

    return <Autocomplete
        sx={{width: "300px"}}
        multiple
        disablePortal
        filterSelectedOptions
        className="ui-autocomplete"
        filterOptions={x => x}
        value={ConsoleDashboardStore.selectedOrthoptists}
        options={ConsoleDashboardStore.orthoptistList}
        getOptionLabel={(option) => option.displayed_value}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(_, array) => ConsoleDashboardStore.setSelectedOrthoptists(array)}
        onInputChange={(event) => ConsoleDashboardStore.loadFilterOrthoptists(event.target.value)}
        renderInput={(params) => <TextField {...params} label="Sélectionner orthoptistes"/>}
    />
})

export default OrthoptistsFilter